/**
 * Canonical customer-activity names and categories used for Splunk logging.
 *
 * These are the single source of truth for the `Functionality` (step label) and
 * `ActivityCategory` fields sent via LoggerService.saveSplunkLog. Keeping them here
 * prevents name drift across call sites so the Customer Activity dashboard can group
 * and order steps reliably.
 */
export const ACTIVITY = {
    LOGIN: "User Login",
    LOGOUT: "User Logout",
    FETCH_APPROVAL_FLOWS: "Fetch Approval Flows",
    FETCH_APPROVAL_LIST: "Fetch Approval List",
    REFRESH_APPROVAL_LIST: "Refresh Approval List",
    FETCH_APPROVAL_DETAILS: "Fetch Approval Details",
    APPROVE_REQUEST: "Approve Request",
    REJECT_REQUEST: "Reject Request",
    FETCH_AGREEMENT_DETAILS: "Fetch Agreement Details",
    APPROVE_AGREEMENT: "Approve Agreement",
    REJECT_AGREEMENT: "Reject Agreement",
    VIEW_AGREEMENT_PDF: "View Agreement PDF",
    DOWNLOAD_AGREEMENT_PDF: "Download Agreement PDF",
};

export const ACTIVITY_CATEGORY = {
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
    FETCH: "FETCH",
    ACTION: "ACTION",
    VIEW: "VIEW",
};

Object.freeze(ACTIVITY);
Object.freeze(ACTIVITY_CATEGORY);
